module.exports = __webpack_public_path__ + "img/922-7a95a2.png";